import { render } from "./DialogEditAlertConfirm.vue?vue&type=template&id=4503bee4&scoped=true"
import script from "./DialogEditAlertConfirm.vue?vue&type=script&lang=js"
export * from "./DialogEditAlertConfirm.vue?vue&type=script&lang=js"

import "./DialogEditAlertConfirm.vue?vue&type=style&index=0&id=4503bee4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4503bee4"]])

export default __exports__